import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// A portable diesel generator set: an engine-alternator block on a steel skid
// frame, with a yellow housing, a control panel, an exhaust stack and a small
// fuel tank. The fallback power source you drop next to a build site.
const HOUSING = "#ffcf3f";
const FRAME = "#3a3a3e";
const PANEL = "#4a4a4e";
const STACK = "#6b7079";
const TANK = "#5a5e64";

export const dieselGenerator = defineModel({
  id: "diesel-generator",
  batchId: "electric",
  name: "Diesel generator",
  tags: ["prop", "electric", "power", "energy", "generator", "diesel", "fossil"],
  summary: "A skid-mounted diesel generator set with exhaust and control panel.",
  footprint: 0.4,
  parts(): Part[] {
    return [
      // Skid frame: two longitudinal rails on stub feet, clearly proud of the ground.
      { geometry: new THREE.BoxGeometry(0.74, 0.06, 0.08), color: FRAME, position: [0, 0.09, -0.16] },
      { geometry: new THREE.BoxGeometry(0.74, 0.06, 0.08), color: FRAME, position: [0, 0.09, 0.16] },
      { geometry: new THREE.BoxGeometry(0.74, 0.04, 0.4), color: "#2a2a2e", position: [0, 0.13, 0] },
      { geometry: new THREE.BoxGeometry(0.04, 0.06, 0.04), color: "#222226", position: [-0.33, 0.03, -0.16] },
      { geometry: new THREE.BoxGeometry(0.04, 0.06, 0.04), color: "#222226", position: [0.33, 0.03, -0.16] },
      { geometry: new THREE.BoxGeometry(0.04, 0.06, 0.04), color: "#222226", position: [-0.33, 0.03, 0.16] },
      { geometry: new THREE.BoxGeometry(0.04, 0.06, 0.04), color: "#222226", position: [0.33, 0.03, 0.16] },
      // Yellow housing over the engine.
      { geometry: new THREE.BoxGeometry(0.62, 0.3, 0.36), color: HOUSING, position: [0, 0.31, 0] },
      { geometry: new THREE.BoxGeometry(0.64, 0.05, 0.38), color: "#e6b733", position: [0, 0.48, 0] },
      // Louvre slats on the side, deeper so they read as cooling vents.
      { geometry: new THREE.BoxGeometry(0.42, 0.03, 0.02), color: "#caa033", position: [-0.05, 0.36, 0.185] },
      { geometry: new THREE.BoxGeometry(0.42, 0.03, 0.02), color: "#caa033", position: [-0.05, 0.3, 0.185] },
      { geometry: new THREE.BoxGeometry(0.42, 0.03, 0.02), color: "#caa033", position: [-0.05, 0.24, 0.185] },
      // Raised control panel enclosure with a screen.
      { geometry: new THREE.BoxGeometry(0.17, 0.24, 0.07), color: PANEL, position: [0.24, 0.32, 0.2] },
      { geometry: new THREE.BoxGeometry(0.11, 0.08, 0.02), color: "#3aa0d0", position: [0.24, 0.38, 0.24] },
      { geometry: new THREE.CylinderGeometry(0.012, 0.012, 0.03, 8), color: "#c4392f", position: [0.24, 0.27, 0.24], rotation: [Math.PI / 2, 0, 0] },
      // Exhaust stack: a thicker pipe with an angled rain cap.
      { geometry: new THREE.CylinderGeometry(0.045, 0.045, 0.3, 10), color: STACK, position: [-0.24, 0.61, -0.1] },
      { geometry: new THREE.CylinderGeometry(0.05, 0.05, 0.06, 10), color: "#4a4a4e", position: [-0.24, 0.78, -0.08], rotation: [0.5, 0, 0] },
      // Belly fuel tank: a wide base the engine housing sits on, on the skid.
      { geometry: new THREE.BoxGeometry(0.68, 0.12, 0.42), color: TANK, position: [0, 0.15, 0] },
      { geometry: new THREE.BoxGeometry(0.62, 0.02, 0.36), color: "#4a4e54", position: [0, 0.21, 0] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.05, 8), color: "#3a3e44", position: [0.26, 0.18, 0.12] },
    ];
  },
  animations: [],
});
